module.exports = __webpack_public_path__ + "static/media/cell-mob@3x.70795e68.png";